export const apiCreate = (): string => '/commercial/origins/create'
export const apiList = (id?: string): string =>
  !id ? '/commercial/origins/' : `/commercial/origins/view/${id}`
export const apiUpdate = (id: string): string =>
  `/commercial/origins/update/${id}`
export const apiDelete = (id: string): string =>
  `/commercial/origins/delete/${id}`
